// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__EQtlF","text":"footer_text__38_sQ","image":"footer_image__bGGhL","ieImage":"footer_ieImage__2gSXq","abta":"footer_abta__3vrw0","atol":"footer_atol__2XJhb"};